import React from 'react';
import { Direction } from '../NavigationDrawer/NavigationDrawer';

export interface GlobalNavState {
    drawerState: {
        left: boolean;
        right: boolean;
    };
}

export interface GlobalNavStateAndHelpers {
    drawerState: {
        left: boolean;
        right: boolean;
    };
    toggleDrawer: (side: Direction, open: boolean) => () => void;
}

export interface GlobalNavProps {
    children(args: GlobalNavStateAndHelpers): React.ReactNode;
}

export default class GlobalNav extends React.Component<GlobalNavProps, GlobalNavState> {
    state: GlobalNavState = {
        drawerState: {
            left: false,
            right: false,
        },
    };

    toggleDrawer = (side: Direction, open: boolean) => () => {
        this.setState(state => ({
            drawerState: {
                ...state.drawerState,
                [side]: open,
            },
        }));
    };

    getStateAndHelpers() {
        return {
            toggleDrawer: this.toggleDrawer,
            ...this.state,
        };
    }

    render() {
        return this.props.children(this.getStateAndHelpers());
    }
}
